export const SET_HEADER_DROPDOWN = "SET_HEADER_DROPDOWN"
export const SET_HEADER_STICKY_CONTENT_OFFSET =
  "SET_HEADER_STICKY_CONTENT_OFFSET"

export function setHeaderDropdown(dropdownName) {
  return { dropdownName, type: SET_HEADER_DROPDOWN }
}

export function setHeaderStickyContentOffset(offset) {
  return { offset, type: SET_HEADER_STICKY_CONTENT_OFFSET }
}
